import React, { useMemo } from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';

import { FieldGroup } from '@xsolla/ui-core';

import { SupplementaryData } from '../../../hooks/types';
import { TagSelector } from '../../ui';
import { defaultTypes, SUPPLEMENTARY_FIELDS } from './utils';

type Props = {
  fieldsData: SupplementaryData;
};

type TagSelectorType = {
  name: keyof typeof defaultTypes;
  active: boolean;
};

const tagSelectorOptions: TagSelectorType[] = [
  { name: SUPPLEMENTARY_FIELDS.username, active: false },
  { name: SUPPLEMENTARY_FIELDS.givenName, active: false },
  { name: SUPPLEMENTARY_FIELDS.familyName, active: true },
  { name: SUPPLEMENTARY_FIELDS.bday, active: false },
  { name: SUPPLEMENTARY_FIELDS.countryName, active: false },
  { name: SUPPLEMENTARY_FIELDS.gender, active: false },
  { name: SUPPLEMENTARY_FIELDS.promoEmailAgreement, active: false },
  { name: SUPPLEMENTARY_FIELDS.additionalAgreement, active: false }
  // ToDo: uncomment, when API will accept phone field as value
  // { name: 'phone_number', active: false }
];

export const FieldSelector = ({ fieldsData }: Props): JSX.Element => {
  const intl = useIntl();

  const tagOptions = useMemo(() => {
    return tagSelectorOptions.reduce(
      (acc, item) => [
        ...acc,
        {
          ...item,
          active: !!fieldsData[item.name],
          tagLabel: intl.formatMessage({
            id: `user-data-base.settings.supplementary-info.field.${item.name}`
          })
        }
      ],
      []
    );
  }, [fieldsData]);

  return (
    <FieldGroup
      label={intl.messages['user-data-base.settings.supplementary-info.fields-additional']}
      size="md">
      <Field name="fields">
        {({ input }) => {
          return <TagSelector options={tagOptions} onChange={input.onChange} />;
        }}
      </Field>
    </FieldGroup>
  );
};
